module.exports = __webpack_public_path__ + "media/images/icons/eject-1f4ddfbff2f8e0585b45578d440febce.svg";